import React from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import moment from 'moment';

const LogModal = ({ show, onHide, logs, statusTypes }) => (
    <Modal show={show} onHide={onHide} size="lg">
        <Modal.Header closeButton>
            <Modal.Title>Status Change Logs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {logs.length > 0 ? (
                <Table bordered responsive>
                    <thead>
                        <tr>
                            <th>Old Status</th>
                            <th>New Status</th>
                            <th className="text-end">Reason</th>
                            <th className="text-end">Updated On</th>
                            <th className="text-end">Updated By</th>
                        </tr>
                    </thead>
                    <tbody>
                        {logs.map((log, index) => (
                            <tr key={index}>
                                <td>{statusTypes[log.old_status]}</td>
                                <td>{statusTypes[log.new_status]}</td>
                                <td className="text-end">{log.reason}</td>
                                <td className="text-end">
                                    {moment(log.updated_at).format("YYYY/MM/DD kk:mm:ss")}
                                </td>
                                <td className="text-end">{log.updatedAdmin ? log.updatedAdmin.name : 'unKnown'}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            ) : (
                <p>No logs available.</p>
            )}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={onHide}>
                Close
            </Button>
        </Modal.Footer>
    </Modal>
);

export default LogModal;